/**
 * PulseCIO - Frontend Application
 * Copyright (c) 2025-2026 Mathieu Lalande. All rights reserved.
 *
 * Hook: usePageTitle
 * Sets the document <title> for the current page.
 * Usage: usePageTitle('Connexion') → document.title = 'Connexion | PulseCIO'
 */

import { useEffect } from 'react';

const APP_NAME = 'PulseCIO';

export default function usePageTitle(title) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}
